import type { MouseEvent } from 'react';

/** idsk/components/skip-link – moves focus to the main landmark. */
export function SkipLink({ href = '#main-content', text }: { href?: string; text: string }) {
  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    const target = document.getElementById(href.slice(1));
    if (target) {
      event.preventDefault();
      target.focus();
      target.scrollIntoView?.();
    }
  };
  return (
    <a href={href} className="govuk-skip-link" onClick={onClick}>
      {text}
    </a>
  );
}
